// Define YouTube reset function FIRST at global scope
// This ensures v2pdp.js can always access it, even before DOMContentLoaded
window.resetYouTubeVideos = function () {
  document
    .querySelectorAll(".product-media-image__youtube-wrapper")
    .forEach((w) => (w.style.display = "block"));
  document
    .querySelectorAll(".product-media-image__video-container")
    .forEach((c) => (c.style.display = "none"));
  document
    .querySelectorAll(".product-media-image__video-iframe")
    .forEach((iframe) => {
      if (iframe.src) {
        iframe.src = "";
      }
    });
  // Remove the style attribute completely when videos are paused/reset
  const featuredSlider = document.querySelector(
    ".product-media-image--featured",
  );
  if (featuredSlider) featuredSlider.removeAttribute("style");
};

document.addEventListener("DOMContentLoaded", function () {
  handleProductMediaSkeleton();
  handleSafetyRatedPopUp();
  // Add badge on initial load after DOM is ready
  window.addSafetyBadgeToFirstSlide();
});

// Also try immediate execution in case DOM is already loaded
if (document.readyState !== "loading") {
  // DOM already loaded, call handleSafetyRatedPopUp immediately
  handleSafetyRatedPopUp();
}

/**
 * Check if Safety Rated badge should be shown based on settings
 */
window.shouldShowSafetyBadge = function () {
  const wrapper = document.querySelector(".product-media-images-wrapper");
  if (!wrapper) return false;

  // Check if feature is enabled in theme settings
  const isEnabled = wrapper.dataset.safetyBadgeEnabled === "true";
  return isEnabled;
};

// Parse variant-level highlight tag data from Liquid-rendered JSON
window.variantHighlightTags = {};
(function () {
  window.normalizeLimitedEditionTag = function (value) {
    const normalizedValue = String(value ?? "").trim().toLowerCase();
    return normalizedValue === "limited edition" ? "Limited Edition" : "";
  };
})();
(function () {
  const el = document.getElementById("variant-highlight-tags-json");
  if (!el) return;
  try {
    window.variantHighlightTags = JSON.parse(el.textContent);
  } catch (e) {
    // Silently fail – badge logic will fall back to no highlight tag.
  }
})();

/**
 * Resolve the current variant's highlight tag from the Liquid-rendered JSON map.
 */
window.getVariantHighlightTag = function (variantIdOverride = null) {
  try {
    const variantId =
      variantIdOverride?.toString() ||
      new URL(window.location.href).searchParams.get("variant") ||
      document.getElementById("v2-pdp-id")?.value;
    if (!variantId || !window.variantHighlightTags) return "";

    const highlightTag = window.variantHighlightTags[variantId];
    if (Array.isArray(highlightTag)) {
      return highlightTag
        .map((tag) => window.normalizeLimitedEditionTag(tag))
        .filter(Boolean)
        .join(", ")
        .trim();
    }

    return window.normalizeLimitedEditionTag(highlightTag);
  } catch (e) {
    return "";
  }
};

/**
 * Add Safety Rated badge to the first image slide, OR show the current variant's
 * highlight tag on the first 2 visible slides when a highlight tag exists.
 * Called after every slide filter update (variant change, add-on toggle, etc.)
 */
window.addSafetyBadgeToFirstSlide = function (variantIdOverride = null) {
  const featuredSlider = document.querySelector(
    ".product-media-image--featured",
  );
  if (!featuredSlider) return;

  const slides = featuredSlider.querySelectorAll(".swiper-slide");
  if (!slides || slides.length === 0) return;

  // ── Step 1: Clean up all existing badges and highlight wrappers ───────────
  slides.forEach((slide) => {
    slide.classList.remove("has-both-badges");
    slide.querySelector(".product-media-image__badge")?.remove();
    slide.querySelector(".product-media-image__highlight-badge")?.remove();

    slide.classList.remove("product-highlight-badge-wrapper");
    slide
      .querySelector(".product-media-image__img-wrapper")
      ?.classList.remove("product-highlight-badge-wrapper");
    slide
      .querySelector(".photochromic-video-block")
      ?.classList.remove("product-highlight-badge-wrapper");

    slide
      .querySelectorAll(".product-highlight-badge-wrapper")
      .forEach((el) => el.classList.remove("product-highlight-badge-wrapper"));
  });

  // ── Step 2: Check if current variant has a highlight tag ──────────────────
  const highlightTag = window.getVariantHighlightTag(variantIdOverride);
  const isVisibleSlide = (slide) => {
    const style = window.getComputedStyle(slide);
    return style.display !== "none" && style.visibility !== "hidden";
  };
  const getHighlightBadgeHost = (slide) =>
    slide.querySelector(".photochromic-video-block") ||
    slide.querySelector(".product-media-image__img-wrapper") ||
    slide;

  if (highlightTag) {
    // Add badge only on the first 2 visible featured slides
    Array.from(slides)
      .filter(isVisibleSlide)
      .slice(0, 2)
      .forEach((slide) => {
        const badgeHost = getHighlightBadgeHost(slide);
        if (!badgeHost) return;

        const badge = document.createElement("span");
        badge.className = "product-media-image__highlight-badge";
        badge.setAttribute("aria-hidden", "true");
        badge.textContent = highlightTag;

        badgeHost.classList.add("product-highlight-badge-wrapper");
        badgeHost.appendChild(badge);
      });
  }

  // LE highlight badge takes precedence over the safety badge.
  if (highlightTag) {
    return;
  }

  // For variants, continue with Safety badge behavior only if enabled.
  if (!window.shouldShowSafetyBadge()) {
    return;
  }

  // ── Step 3: Non-LE – add Safety Rated badge to first suitable image slide ─
  const firstImageSlide = Array.from(slides).find((slide) => {
    if (!isVisibleSlide(slide)) return false;
    const hasImage = slide.querySelector(".product-media-image__img-wrapper");
    const isVideoSlide = slide.querySelector(
      ".product-media-image__youtube-wrapper",
    );
    const imgElement = slide.querySelector("img");
    const altText = (imgElement?.getAttribute("alt") || "").toLowerCase();
    const isFloatie = altText.includes("floatie");
    const isPhotochromic = altText.includes("photochromic");
    return hasImage && !isVideoSlide && !isFloatie && !isPhotochromic;
  });

  if (!firstImageSlide) return;
  if (firstImageSlide.querySelector(".product-media-image__badge")) return;

  const badge = document.createElement("button");
  badge.id = "safety-rated-badge";
  badge.className = "product-media-image__badge";
  badge.type = "button";
  badge.setAttribute("aria-label", "Safety Rated and ANSI Z87.1 Certified");

  badge.innerHTML = `
      <span class="safety-rated--badge">SAFETY RATED</span>
      <span class="ansi--badge">
        ANSI Z87.1
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3346 4L6.0013 11.3333L2.66797 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    `;

  if (highlightTag) {
    firstImageSlide.classList.add("has-both-badges");
  }

  firstImageSlide.appendChild(badge);
};

function handleProductMediaSkeleton() {
  // console.log('Initializing product media skeleton handling');

  const loadingSkeleton = document.querySelector(
    ".product-media-images__loading",
  );
  const featuredSlider = document.querySelector(
    ".product-media-image--featured",
  );
  const thumbnailWrapper = document.querySelector(
    ".product-media-images__thumbnail-wrapper",
  );

  // Function to hide skeleton - will be called after filtering completes
  window.hideProductMediaSkeleton = () => {
    // console.log('Hiding skeleton after filtering complete');
    if (loadingSkeleton) loadingSkeleton.style.display = "none";
    if (featuredSlider)
      featuredSlider.classList.remove("product-media-image--loading");
    if (thumbnailWrapper)
      thumbnailWrapper.classList.remove(
        "product-media-images__thumbnail-wrapper--loading",
      );

    // Add safety badge after skeleton is hidden
    window.addSafetyBadgeToFirstSlide();
  };

  // Initialize Swipers with skeleton still showing
  // Store globally so v2pdp.js can re-attach event listeners after rebuild
  window.productMediaFeaturedSwiper = new Swiper(
    ".product-media-image--featured",
    {
      slidesPerView: 1,
      spaceBetween: 10,
      // Wrap navigation past the ends so arrows stay enabled in both directions.
      // Using `rewind` (not `loop`) avoids Swiper's duplicate-slide clones, which
      // would break the safety/LE badge selectors and v2pdp.js's slideTo(0) reset.
      rewind: true,
      // Enable click events and allow propagation for safety badge
      simulateTouch: true,
      touchEventsTarget: "wrapper",
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: ".swiper-button-next.product-media-image__swiper-button-next",
        prevEl: ".swiper-button-prev.product-media-image__swiper-button-prev",
      },
      thumbs: {
        swiper: {
          el: ".product-media-image--thumbnail",
          slidesPerView: 5,
          spaceBetween: 5,
          watchSlidesProgress: true,
        },
      },
      on: {
        init: function () {
          // console.log('Swiper initialized - ready for filtering');
          // Signal that swiper is ready for filtering
          window.productMediaSwiperReady = true;
        },
        // Don't interfere with safety badge clicks
        click: function (swiper, event) {
          // If clicking on badge, let it propagate normally
          if (event.target.closest(".product-media-image__badge")) {
            return; // Don't interfere with badge popup
          }
        },
      },
    },
  );

  // Fallback: Hide skeleton after timeout if filtering doesn't complete
  setTimeout(() => {
    if (loadingSkeleton && loadingSkeleton.style.display !== "none") {
      // console.log('Fallback: Force hiding skeleton after timeout');
      window.hideProductMediaSkeleton();
    }
  }, 3000);

  // YouTube functionality (only if delegation is not provided by v2PdpJs)
  if (!window.__v2PdpDelegatedYT) {
    const playButtons = document.querySelectorAll(
      ".product-media-image__youtube-wrapper button:not(.webm-play-btn)",
    );
    if (playButtons && playButtons.length > 0) {
      playButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.stopPropagation();
          const videoId = this.getAttribute("data-video-id");
          const slide = this.closest(".product-media-image__slide");
          const wrapper = this.closest(".product-media-image__youtube-wrapper");
          const videoContainer = slide.querySelector(
            ".product-media-image__video-container",
          );
          const iframe = slide.querySelector(
            ".product-media-image__video-iframe",
          );
          if (videoId && iframe) {
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0`;
            wrapper.style.display = "none";
            videoContainer.style.display = "block";
            const featuredSlider = document.querySelector(
              ".product-media-image--featured",
            );
            if (
              featuredSlider &&
              window.matchMedia("(min-width: 560px)").matches
            ) {
              if (window.matchMedia("(min-width:560px)").matches) {
                featuredSlider.style.height = "430px";
              }
            }
          }
        });
      });
    }

    // Native Video functionality (WEBM, MP4, etc.)
    const nativePlayButtons = document.querySelectorAll(
      ".native-video-play-btn",
    );
    if (nativePlayButtons && nativePlayButtons.length > 0) {
      nativePlayButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.stopPropagation();
          const slide = this.closest(".product-media-image__slide");
          const wrapper = this.closest(
            ".product-media-image__native-video-wrapper",
          );

          if (!slide || !wrapper) return;

          const videoContainer = slide.querySelector(
            ".product-media-image__video-container",
          );
          const video = slide.querySelector("video");

          if (video && videoContainer) {
            wrapper.style.display = "none";
            videoContainer.style.display = "block";
            video.play();

            // Add a pause listener to show the button again when native controls are used to pause
            if (!video.dataset.pauseBound) {
              let isSeekPause = false;

              video.addEventListener("seeking", () => {
                isSeekPause = true;
              });

              video.addEventListener("play", () => {
                isSeekPause = false;
              });

              video.addEventListener("pause", () => {
                setTimeout(() => {
                  if (isSeekPause || !video.paused) return;
                  videoContainer.style.display = "none";
                  wrapper.style.display = "block";
                }, 100);
              });

              video.dataset.pauseBound = "true";
            }

            const featuredSlider = document.querySelector(
              ".product-media-image--featured",
            );
            if (
              featuredSlider &&
              window.matchMedia("(min-width: 560px)").matches
            ) {
              featuredSlider.style.height = "430px";
            }
          }
        });
      });
    }
  }

  // Attach YouTube reset handler to slideChange event
  // Function is already defined globally at the top of the file
  if (
    window.productMediaFeaturedSwiper &&
    typeof window.resetYouTubeVideos === "function"
  ) {
    window.productMediaFeaturedSwiper.on(
      "slideChange",
      window.resetYouTubeVideos,
    );
  }
}

/**
 * Handle Safety Rated popup using event delegation
 * This works even when badge is dynamically created/recreated
 */
function handleSafetyRatedPopUp() {
  const popupTemplate = document.getElementById("safety-rated-popup-template");
  if (!popupTemplate) return;

  // Store the element that triggered the popup for focus restoration
  let triggerElement = null;

  // Wait for featured slider to be in DOM
  const attachHandler = () => {
    const featuredSlider = document.querySelector(
      ".product-media-image--featured",
    );

    if (!featuredSlider) {
      // Retry on next frame if not ready
      requestAnimationFrame(attachHandler);
      return;
    }

    // Attach click handler to parent (event delegation) with capture phase
    featuredSlider.addEventListener(
      "click",
      function (e) {
        const badge = e.target.closest(".product-media-image__badge");
        if (!badge) return;

        e.preventDefault();
        e.stopPropagation();

        // Store trigger element for focus restoration
        triggerElement = badge;

        // Clone and insert popup
        const popupContent = popupTemplate.content.cloneNode(true);
        document.body.appendChild(popupContent);

        const popup = document.querySelector(".safety-rated-popup");
        const overlay = popup.querySelector(".safety-rated-popup__overlay");
        const closeBtn = popup.querySelector(".safety-rated-popup__close");
        const popupContentEl = popup.querySelector(
          ".safety-rated-popup__content",
        );

        // Get all focusable elements for keyboard trap
        const focusableElements = popupContentEl.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        // Show popup
        requestAnimationFrame(() => {
          popup.classList.add("is-visible");
          // Focus close button for accessibility
          closeBtn.focus();
        });

        // Trap focus within popup
        const trapFocus = (e) => {
          if (e.key === "Tab") {
            if (e.shiftKey) {
              // Shift + Tab
              if (document.activeElement === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
              }
            } else {
              // Tab
              if (document.activeElement === lastFocusable) {
                e.preventDefault();
                firstFocusable.focus();
              }
            }
          }
        };

        // Close handlers
        const closePopup = () => {
          popup.classList.remove("is-visible");

          // Remove focus trap
          popup.removeEventListener("keydown", trapFocus);

          // Restore focus to trigger element
          setTimeout(() => {
            popup.remove();
            if (triggerElement) {
              triggerElement.focus();
            }
          }, 300);
        };

        // Attach focus trap
        popup.addEventListener("keydown", trapFocus);

        closeBtn.addEventListener("click", closePopup);
        overlay.addEventListener("click", closePopup);

        // ESC key to close
        const handleEsc = (e) => {
          if (e.key === "Escape") {
            closePopup();
            document.removeEventListener("keydown", handleEsc);
          }
        };
        document.addEventListener("keydown", handleEsc);
      },
      true,
    ); // Use capture phase to intercept before Swiper
  };

  // Start attaching handler
  attachHandler();
}
